import * as React from "react";

import { Form, Checkbox, CheckboxProps } from "semantic-ui-react";
import { QuestionWrapper } from "@teamprevent/common/questionnaires/components/questions/QuestionWrapper";

import { QuestionProps, AnsweredQuestion } from "../../model";
import { isQuestionDisabled } from "../../questionnaireConfig/models";

import "../../styles/questions/checkbox-question.scss";

export const Checked = "Yes";

interface CheckboxQuestionAdditionalProps {
    value: string;
    addAsteriskIfMandatory?: boolean;
}

type CheckboxQuestionProps = QuestionProps & CheckboxQuestionAdditionalProps;

class CheckboxQuestion extends React.Component<CheckboxQuestionProps> {
    constructor(props: CheckboxQuestionProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    public render() {
        if (isQuestionDisabled(this.props.questionConfig)) {
            return null;
        }

        return (
            <QuestionWrapper
                inline={this.props.inline}
                question={null}
                hideDivider={this.props.hideDivider}
                error={this.props.showError && this.props.mandatory && !this.props.answer && "This field must be checked"}
                readonly={this.props.readonly}
                removable={{
                    ...this.props.removable,
                    questionId: this.props.questionConfig.id,
                    isRemovedByUser: this.props.isRemovedByUser
                }}
                outdated={{
                    ...this.props.outdated,
                    questionId: this.props.questionConfig.id
                }}
            >
                <Form.Field>
                    <Checkbox
                        label={<label dangerouslySetInnerHTML={{ __html: this.props.questionConfig.questionText
                            + (this.props.mandatory && this.props.addAsteriskIfMandatory ? "*" : "") }} />}
                        checked={this.props.answer === this.props.value}
                        onChange={this.onChange}
                        readOnly={this.props.readonly}
                        className={this.props.readonly ? "readonly-checkbox" : ""}
                    />
                </Form.Field>
            </QuestionWrapper>
        );
    }

    private onChange(event: React.MouseEvent<HTMLInputElement>, data: CheckboxProps) {
        if (isQuestionDisabled(this.props.questionConfig)) {
            return;
        }

        const answer = data.checked ? this.props.value : "";
        const newQuestion: AnsweredQuestion = { question: this.props.questionConfig.questionText, answer, isValid: !!answer || !this.props.mandatory };
        this.props.updateQuestion(newQuestion);
        if (this.props.onAnswerChange) {
            this.props.onAnswerChange(newQuestion.answer);
        }
    }
}

export { CheckboxQuestion };
